/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestspeopleacceptedone3Inputs */

const en_requestspeopleacceptedone3 = /** @type {(inputs: Requestspeopleacceptedone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 person accepted`)
};

const de_requestspeopleacceptedone3 = /** @type {(inputs: Requestspeopleacceptedone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Person angenommen`)
};

/**
* | output |
* | --- |
* | "1 person accepted" |
*
* @param {Requestspeopleacceptedone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestspeopleacceptedone3 = /** @type {((inputs?: Requestspeopleacceptedone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestspeopleacceptedone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestspeopleacceptedone3(inputs)
	return de_requestspeopleacceptedone3(inputs)
});
export { requestspeopleacceptedone3 as "requestsPeopleAcceptedOne" }